/*
*/

import layerVector from '../node_modules/ol/layer/Vector.js';
import sourceVector from '../node_modules/ol/source/Vector.js';
import Feature from '../node_modules/ol/Feature.js';
import Point from '../node_modules/ol/geom/Point.js';

export default function(map) {
  let positionFeature = new Feature();
  let layer = new layerVector({
    title: 'lyrLatLonMarker',
    source: new sourceVector({
      features: [positionFeature]
    }),
    style: {  // object literal Style - definitions in node_modules/ol/style/flat.js
      "circle-radius": 10,
      "circle-fill-color": 'rgba(255, 165, 0, 0.5)', //  'orange'
      "circle-stroke-color": '#f00',
      "stroke-width": 2
    },
    zIndex: 6,
  })

  map.addLayer(layer);

  this.clear = function() {
    positionFeature.setGeometry(null);
  };

  this.go = function() {
    let content = document.getElementById('rwg-dialog-content');
    content.innerHTML = `<h3>Go to Longitude Latitude</h3>
      <ul style="padding-left:8px">
        <li>Latitude, Longitude must be separated by a comma</li>
        <li>Can be in either order (lat,lon or lon,lat)</li>
        <li>Can be decimal degrees or degrees minutes seconds or degrees decimal minutes</li>
        <li>Degrees minutes seconds must be separated by a space, character or symbol</li>
      </ul>
      <form>
        <input size="50" type="text" id="input-latlon">
        <p>
        <button id="btn-go" style="margin-right: 15px;" class="rwg-btn">Go to Longitude Latitude</button>
        <button id="btn-cancel" class="rwg-btn">Cancel</button>
      </form>`
    document.getElementById('rwg-dialog').style.display = 'block'
    document.getElementById('btn-go').onclick = callback
    document.getElementById('btn-cancel').onclick = cancel
    document.getElementById('input-latlon').focus()

    function callback(evt) {
      evt.preventDefault();

      // Private function parseDMS() converts DMS to decimal degrees
      // Always returns a positive number
      function parseDMS(val) {
        let dms = val.replace(/[^0-9.]+/g, ' ').trim().split(' ') // regex replaces anything that's not a digit or decimal
        if (dms.length > 1) {  // user entered one or more delimiters, assume  D M or D M S
          if (dms.length === 3) { // assume user entered seconds
            dms[2] = (dms[2] > 60) ? 'x' : dms[2] / 60;  // assigning 'x' will force a NaN
            dms[1] = (dms[1] * 1) + dms[2];
          }
          dms[1] = (dms[1] > 60) ? 'x' : dms[1] / 60;  // assigning 'x' will force a NaN
          dms[0] = parseFloat(dms[0]) + dms[1]
        }
        if (isNaN(dms[0]) ) {
          alert(`${val} is invalid`);
          dms[0] = false
        }
        return dms[0];
      }

      let lat, lon
      let input = document.getElementById('input-latlon').value.split(',')
      if (input.length !==2) {
        alert('Error: Be sure that lat and lon are separated by a comma\nand that there are no other commas in your entry.')
        return
      }
      let a = parseDMS(input[0])
      let b = parseDMS(input[1])
      // this assumes north america and positive longitude
      if (a && b) {
        if (a > 60) {
          lon = a
          lat = b
        } else {
          lon = b
          lat = a
        }
      }

      let p =rwg.proj.transform('EPSG:4326', rwg.proj.mapSRID, [lon * (-1), parseFloat(lat)]) // values are always absolute (positive) so make lon negative (west)
      if (isNaN(p[0]) || p[0] < rwg.config.olView.extent[0] || p[0] > rwg.config.olView.extent[2] ) {
        alert('Longitude ' + lon + ' out of range ');
        return;
      }
      if (isNaN(p[1]) || p[1] < rwg.config.olView.extent[1] || p[1] > rwg.config.olView.extent[3] ) {
        alert('Latitude ' + lat + ' out of range');
        return;
      }

      let view = map.getView()
      let resolution = view.getProjection().getUnits() === 'm' ? 3 : 9;
      view.setResolution(resolution); // and possibly bounce to location
      view.setCenter(p);

      positionFeature.setGeometry(new Point(p))

      document.getElementById('rwg-dialog-content').innerHTML = '';
      document.getElementById('rwg-dialog').style.display = 'none';

    }  // callback()

    function cancel(evt) {
      evt.preventDefault();
      document.getElementById('rwg-dialog-content').innerHTML = '';
      document.getElementById('rwg-dialog').style.display = 'none';
    }

  };

}
